import { cva, VariantProps } from 'class-variance-authority';
import { ComponentPropsWithoutRef, ElementType, ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

const cardVariants = cva(['relative', 'block bg-card-color theme-custom:bg-transparent'], {
    variants: {
        variant: {
            gallery: ['p-4', 'rounded-2xl', 'cursor-pointer'],
            wrapper: [
                'rounded-xl',
                'shadow-[0px_4px_16px_rgba(228,234,237,0.8)] dark:shadow-[0px_4px_16px_rgba(10,10,10,0.8)] theme-custom:shadow-[0px_4px_16px_rgba(228,234,237,0.1)]',
            ],
        },
        hover: {
            true: 'transition-shadow duration-300 hover:shadow-[0px_4px_16px_rgba(4,34,99,0.08)]',
            false: '',
        },
    },
    defaultVariants: {
        variant: 'gallery',
        hover: false,
    },
});

interface CardProps<T extends ElementType> extends VariantProps<typeof cardVariants> {
    as?: T;
}

const CardInner = <T extends ElementType>(
    props: CardProps<T> & ComponentPropsWithoutRef<T>,
    ref: ForwardedRef<HTMLDivElement>
) => {
    const { children, as, className, variant, hover = false, ...rest } = props;

    const Component = as || 'div';

    return (
        <Component {...rest} ref={ref} className={twMerge(cardVariants({ variant, hover, className }))}>
            <div className="absolute inset-0 rounded-[inherit] hidden theme-custom:block theme-custom:bg-white/70 theme-custom:backdrop-blur-normal"></div>
            <div className="relative h-full">{children}</div>
        </Component>
    );
};

const Card = forwardRef(CardInner);

export default Card;
